import { useState, useEffect } from 'react';

export default function HittingPercentageCalculator() {
  const [kills, setKills] = useState('');
  const [errors, setErrors] = useState('');
  const [attempts, setAttempts] = useState('');
  const [percentage, setPercentage] = useState(0);
  const [rating, setRating] = useState('Enter your stats above');
  const [color, setColor] = useState('#6B6966');

  useEffect(() => {
    calculatePercentage();
  }, [kills, errors, attempts]);

  function calculatePercentage() {
    const k = parseFloat(kills) || 0;
    const e = parseFloat(errors) || 0;
    const a = parseFloat(attempts) || 0;

    if (a === 0) {
      setPercentage(0);
      setColor('#6B6966');
      setRating('Enter your stats above');
      return;
    }

    const pct = (k - e) / a;
    setPercentage(pct);

    let newRating = '';
    let newColor = '';

    if (pct >= 0.400) {
      newRating = 'Elite';
      newColor = '#2D8659'; // --success
    } else if (pct >= 0.300) {
      newRating = 'Excellent';
      newColor = '#2E5AAC'; // --primary
    } else if (pct >= 0.200) {
      newRating = 'Good';
      newColor = '#D97706'; // --warning
    } else if (pct >= 0.100) {
      newRating = 'Needs Improvement';
      newColor = '#D44C47'; // --danger
    } else {
      newRating = 'Focus on Consistency';
      newColor = '#D44C47'; // --danger
    }

    setColor(newColor);
    setRating(newRating);
  }

  return (
    <div style={{
      background: 'linear-gradient(135deg, #2E5AAC 0%, #1E4A9C 100%)',
      padding: '32px',
      borderRadius: '12px',
      margin: '32px 0',
      boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
    }}>
      <h3 style={{
        color: 'white',
        marginTop: 0,
        marginBottom: '24px',
        fontSize: '24px',
        textAlign: 'center',
        fontWeight: '700'
      }}>
        Hitting Percentage Calculator
      </h3>

      <div style={{
        background: 'white',
        padding: '24px',
        borderRadius: '10px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#37352F',
            fontSize: '14px'
          }}>
            Kills
          </label>
          <input
            type="number"
            min="0"
            value={kills}
            onChange={(e) => setKills(e.target.value)}
            placeholder="0"
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              border: '1px solid #E3E2DF',
              borderRadius: '6px',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s, box-shadow 0.2s'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#2E5AAC';
              e.target.style.boxShadow = '0 0 0 3px rgba(46,90,172,0.15)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#E3E2DF';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#37352F',
            fontSize: '14px'
          }}>
            Errors
          </label>
          <input
            type="number"
            min="0"
            value={errors}
            onChange={(e) => setErrors(e.target.value)}
            placeholder="0"
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              border: '1px solid #E3E2DF',
              borderRadius: '6px',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s, box-shadow 0.2s'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#2E5AAC';
              e.target.style.boxShadow = '0 0 0 3px rgba(46,90,172,0.15)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#E3E2DF';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{
            display: 'block',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#37352F',
            fontSize: '14px'
          }}>
            Total Attempts
          </label>
          <input
            type="number"
            min="0"
            value={attempts}
            onChange={(e) => setAttempts(e.target.value)}
            placeholder="0"
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '16px',
              border: '1px solid #E3E2DF',
              borderRadius: '6px',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s, box-shadow 0.2s'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#2E5AAC';
              e.target.style.boxShadow = '0 0 0 3px rgba(46,90,172,0.15)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#E3E2DF';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{
          background: '#F7F6F3',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center',
          border: '1px solid #E3E2DF'
        }}>
          <div style={{
            fontSize: '13px',
            color: '#6B6966',
            marginBottom: '8px',
            fontWeight: '600',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Your Hitting Percentage
          </div>
          <div style={{
            fontSize: '48px',
            fontWeight: '700',
            color: color,
            marginBottom: '8px'
          }}>
            {percentage.toFixed(3)}
          </div>
          <div style={{
            fontSize: '16px',
            fontWeight: '600',
            color: color
          }}>
            {rating}
          </div>
        </div>
      </div>
    </div>
  );
}
